import React from 'react';
import UserAgreementModal from '../../UserAgreementModal';
import { AdminNavMenu } from './AdminNavMenu';
import { AdminNavSideMenu } from './AdminNavSideMenu';

const AdminPortalLayout: React.FC<{ children?: React.ReactNode }> = ({ children }) => <>
  <UserAgreementModal />
  <AdminNavMenu />
  <main id="content" role="main" className="navbar-sidebar-aside-sm">
    <AdminNavSideMenu />
    <div className="navbar-sidebar-aside-content content-space-t-3 content-space-b-2 px-lg-5 px-xl-10 height-100 d-flex flex-column">
      {children}
    </div>
  </main>
</>

export { AdminPortalLayout };
